import { Context3D } from './3d-context'

export function exportVariant(context = Context3D.get()) {
  if (!context.scene) return
}
